interface ImageProps {
  src: string;
  className?: string;
  setLoaded?: (loaded: boolean) => void;
}

function Image({ src, className, setLoaded }: ImageProps) {
  const onLoad = () => {
    if (setLoaded) {
      setLoaded(true);
    }
  };

  return <img src={src} alt="" onLoad={onLoad} className={className} />;
}

export default Image;
